<storever-loading-data *ngIf="isLoading else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="form" class="formHeight">
    <ul class="list-group">
      <div class="width-25">
        <storever-element-group
          [icon]="'fa-map-marker-alt'"
          [title]="'ORDER_FORM_TITLE_SITE'"
          [config]="formConfigSite.config"
          [form]="form.get(['site'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'none', icon: 'none', type: 'order', case: 'none'}"
          (save)="save('site')"
          (undo)="undo(['site'])"
          [stylingClass]="'dynamic-form'">
                </storever-element-group>
              </div>
        <!--      <div class="width-25 colSite2">-->
<!--        <storever-element-group-->
<!--          [icon]=""-->
<!--          [title]="null"-->
<!--          [config]="formConfigSiteOthers.config"-->
<!--          [form]="form.get(['site'])"-->
<!--          [isAdd]="isAdd"-->
<!--          [isEdit]="isEdit"-->
<!--          [isExchange]="isExchange"-->
<!--          [status]="order && isEdit ? order.status  : 'exchange'"-->
<!--          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'site'}"-->
<!--          (save)="save('site')"-->
<!--          (undo)="undo(['site'])"-->
<!--          [stylingClass]="'dynamic-form'">-->
<!--        </storever-element-group>-->
<!--      </div>-->
      <div class="width-25 colSite1">
<!--        {{formConfigSubscriptionOthers.config |json}}-->
<!--        {{form.get(['subscription']).value |json}}-->
        <storever-element-group
          [icon]="'fa-building'"
          [title]="'ORDER_FORM_TITLE_SUBSCRIPTION'"
          [config]="formConfigSubscriptionOthers.config"
          [form]="form.get(['subscription', 'general'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'subscription'}"
          (save)="save('subscription')"
          (undo)="undo(['subscription'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group><br>
<!--        <div class="width-25">-->
          <storever-element-group *ngIf="isConcepts"
            [icon]="'fa-clipboard-list'"
            [title]="'Concepts'"
            [config]="getConfigConcepts.config"
            [form]="form.get(['concepts'])"
            [isAdd]="isAdd"
            [isEdit]="isEdit"
            [isExchange]="isExchange"
            [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
            [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'subscription'}"
            (save)="save('concepts')"
            (undo)="undo(['concepts'])"
            [stylingClass]="'dynamic-form'">
          </storever-element-group>
<!--        </div>-->
      </div>
      <div class="width-25 colSite2">
        <storever-element-group
          [icon]=""
          [title]=""
          [config]="formConfigSubscription.config"
          [form]="form.get(['subscription', 'base', 'productForm'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'subscription'}"
          (save)="save('subscription')"
          (undo)="undo(['subscription'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group
          *ngIf="(cms$|async)?.length > 0 && isPlayer"
          [icon]="'fa-server'"
          [title]="'ORDER_FORM_SERVERS'"
          [config]="getConfigServer.config"
          [form]="form.get(['subscription', 'base', 'serverForm'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'server'}"
          (save)="save('server')"
          (undo)="undo(['subscription', 'base', 'serverForm'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
        <storever-element-group *ngIf="isPlayer"
          [icon]="'fa-calendar-check'"
          [title]="'ORDER_FORM_TITLE_MISCELLANEOUS'"
          [config]="getConfigOrderMiscDatePicker?.config"
          [form]="form.get(['misc', 'expeditionForm'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [orderType]="order?.type"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'dispatchDate'}"
          (save)="save('dispatchDate')"
          (undo)="undo(['misc', 'expeditionForm'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="'ORDER_FORM_TITLE_ADDRESS'"
          [config]="formConfigAddress.config"
          [form]="getArrayAddress(0)"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [tooltipText]="order && order.sfAliID ? 'ORDER_NOT_ALLOWED_TEXT_SALESFORCE' : ''"
          [status]="(!isInternalUser ? '8' : (order && isEdit && !order.sfAliID ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'address'}"
          (save)="save('addressSite')"
          (undo)="undo(['addresses', '0'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="'ORDER_FORM_TITLE_ADDRESS_DELIVERY'"
          [config]="getConfigDeliveryAddress.config"
          [form]="getArrayAddress(1)"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [tooltipText]="order && order.sfAliID ? 'ORDER_NOT_ALLOWED_TEXT_SALESFORCE' : ''"
          [status]="(!isInternalUser ? '8' : (order && isEdit && !order.sfAliID ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'address'}"
          (save)="save('addressShipping')"
          (undo)="undo(['addresses', '1'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group
          [icon]="'fa-id-card'"
          [title]="'ORDER_FORM_TITLE_CONTACT'"
          [config]="formConfigContact.config"
          [form]="form.get('contact')"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [tooltipText]="order && order.sfAliID ? 'ORDER_NOT_ALLOWED_TEXT_SALESFORCE' : ''"
          [status]="(!isInternalUser ? '8' : (order && isEdit && !order.sfAliID ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'contact'}"
          (save)="save('contact')"
          (undo)="undo(['contact'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25" *ngIf="isPlayer">
        <storever-element-group
          [icon]="'fa-network-wired'"
          [title]="'ORDER_FORM_TITLE_SUB_NET_IP'"
          [config]="getConfigOrderSubNetIp.config"
          [form]="form.get(['subscription', 'network', 'ipAddress'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'network'}"
          [orderType]="order?.type"
          (save)="save('network')"
          (undo)="undo(['subscription', 'network', 'ipAddress'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
        <storever-element-group *ngIf="isPlayer"
          [icon]="'fa-network-wired'"
          [title]="'ORDER_FORM_TITLE_SUB_NET_PROXY'"
          [config]="getConfigOrderSubNetProxy.config"
          [form]="form.get(['subscription', 'network', 'proxy'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'proxy'}"
          (save)="save('proxy')"
          (undo)="undo(['subscription', 'network', 'proxy'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
        <storever-element-group
          *ngIf="isVideo && !isLoading && isPlayer"
          [icon]="'fa-wifi'"
          [title]="'ORDER_FORM_TITLE_SUB_NET_WIFI'"
          [config]="getConfigOrderSubNetWifi.config"
          [form]="form.get(['subscription', 'network', 'wifi'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isLoadingBlock]="isLoadingWifi"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'wifi'}"
          (save)="save('wifi')"
          (undo)="undo(['subscription', 'network', 'wifi'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <div *ngIf="isPlayer">
          <storever-element-group
            [icon]="'fad fa-industry-alt'"
            [title]="'PRODUCTION_LINE'"
            [config]="getConfigProductionLine.config"
            [form]="form.get(['productionLine'])"
            [isAdd]="isAdd"
            [isEdit]="isEdit"
            [isExchange]="isExchange"
            [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
            [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'site'}"
            (save)="save('productionLine')"
            (undo)="undo(['productionLine'])"
            [stylingClass]="'dynamic-form'">
          </storever-element-group>
        </div>
        <storever-element-group
          [icon]="'fa-comment-alt-lines'"
          [title]="'GENERIC_COMMENT'"
          [config]="getConfigOrderMisc.config"
          [form]="form.get(['misc', 'commentsForm'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'GENERIC_ADD', icon: 'fal fa-comment-plus', type: 'order', case: 'comments'}"
          (save)="save('comments')"
          (undo)="undo(['misc', 'commentsForm'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
        <storever-element-group
          *ngIf="isEdit && (order?.status > 0)"
          [icon]="'fal fa-hdd'"
          [title]="'GENERIC_PLAYER_INFO'"
          [config]="getConfigOrderMiscPlayer.config"
          [form]="form.get(['misc', 'playerInfo'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [paramEdit]="{text: 'GENERIC_REMOVE', icon: 'fal fa-trash-alt', type: 'order', case: 'player'}"
          [status]="order && isEdit ? order.status  : 'exchange'"
          [stylingClass]="'dynamic-form'"
          (removeOutput)="removePlayer()">
        </storever-element-group>
        <storever-element-group
          *ngIf="isEdit"
          [icon]="'fa-info-circle'"
          [title]="'ORDER_FORM_TITLE_OTHERS'"
          [config]="getConfigOrderMiscCreated.config"
          [form]="form.get(['misc', 'byForm'])"
          [isAdd]="isAdd"
          [nextSuggestedDate]="nextSuggestedDate"
          [isEdit]="isEdit"
          [isExchange]="isExchange"
          [status]="(!isInternalUser ? '8' : (order && isEdit ? order.status  : 'exchange'))"
          [paramEdit]="{text: 'none', icon: 'none', type: 'order', case: 'none'}"
          [stylingClass]="'dynamic-form'" >
        </storever-element-group>
      </div>
    </ul>
  </form>
</ng-template>
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
<!--  <pre style="flex: 1 1 0px">form: {{form.get(['subscription', 'base', 'serverForm']).value|json}}</pre>-->
<!--  <pre style="flex: 1 1 0">config: {{getConfigOrderSubNetWifi.config|json}}</pre>-->
  <pre style="flex: 1 1 0px">dataConfig form: {{getInvalidControls(form)}}</pre>
</div>
